import "@/App.css";
import Dashboard from "@/components/Dashboard";
import Login from "@/components/Login";
import { AuthProvider, useAuth } from "@/lib/auth";

function Shell() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#06090E] text-slate-500 font-mono text-xs tracking-wider">
        INICIALIZANDO RESILIO.ES…
      </div>
    );
  }
  if (!user) return <Login />;
  return <Dashboard />;
}

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </div>
  );
}

export default App;
